export default {
  asFeatured: {
    en: 'As featured in',
  },
  featuredQuote: {
    en: 'Scent-sational monthly subscription box that delivers a new perfume to your doorstep each month.',
  },
}
